import { Component, OnInit, Inject } from "@angular/core";
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from "@angular/material";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { QRCode } from "../../forked/qr_code";
import { CoreLanguageService } from "../../services/language.service";

export interface BasketPayOptionsDialogModaldata {
  /** Eindeutige Tischnummer an POS */
  posTableNumber: string;
  /** optional Gruppenname */
  groupName: string | null;
  /** Anzeige Tischnummer */
  tableNumber: string;
}

@Component({
  selector: "basketPayConfirmDialog",
  templateUrl: "./basketPayConfirmDialog.component.html",
  styleUrls: ["./basketPayConfirmDialog.component.scss"],
})
export class BasketPayConfirmDialogComponent implements OnInit {

  /** Tischinformation */
  public get tableInfo(): string {
    const me = this;
    if (me.modalData.groupName)
      return me._coreLanguageService.value("phInHouseService_Group").replace("{group}", me.modalData.groupName);
    else
      return me._coreLanguageService.value("phInHouseService_Table").replace("{table_no}", me.modalData.tableNumber);
  }

  /** Representiert den Tisch als QR zum Öffnen am POS */
  public posTableNumberQrCodeSvg: SafeHtml;

  /** Tischnummer am POS */
  public get posTableNumber(): string {
    return this.modalData.posTableNumber
  }

  constructor(
    public bottomSheetRef: MatBottomSheetRef<BasketPayConfirmDialogComponent>
    , private _router: Router
    , private _coreLanguageService: CoreLanguageService
    , private _sanitized: DomSanitizer
    , @Inject(MAT_BOTTOM_SHEET_DATA) private modalData: BasketPayOptionsDialogModaldata,
  ) { }

  ngOnInit() {
    const me = this;
    const tablenumberqrcode = "?tAbvRGnR=" + me.posTableNumber;
    const qrcodesvg = new QRCode(tablenumberqrcode).svg();
    me.posTableNumberQrCodeSvg = me._sanitized.bypassSecurityTrustHtml(qrcodesvg);
  }

  public discardToMenuGroup() {
    const me = this;
    me.bottomSheetRef.dismiss();
  }

  public BackBtn() {
    const me = this;
    me._router.navigate(["/inHouseTableOverview"]);
    me.bottomSheetRef.dismiss();
  }
}
